<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div class="mt-1" v-else>
      <v-row>
        <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">รายการบิลย้อนหลัง</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
      </v-row>
      <div class="mt-1">
        <v-card elevation="3" class="pa-4" style="border-radius: 15px">
          <section class="d-flex justify-space-between">
            <v-row>
              <v-col xs="6" sm="6" md="9" lg="9" xl="9" cols="6">
                <v-tabs color="#D6BFAF">
                  <v-tab @click="tabs(1)">รายการบิลทั้งหมดวันนี้</v-tab>
                  <v-tab @click="tabs(2)">รายการบิลทั้งหมดย้อนหลัง</v-tab>
                </v-tabs>
              </v-col>
              <v-col xs="6" sm="6" md="3" lg="3" xl="3" cols="6">
                <div class="mt-1">
                  <v-text-field color="#D6BFAF" class="input-radius" append-icon="mdi-magnify" hide-details="auto"
                    required v-model="search" placeholder="ค้นหา..." outlined dense></v-text-field>
                </div>
              </v-col>
            </v-row>
          </section>

          <section class="pa-3">
            <v-row>
              <v-col cols="12" xs="12" sm="12" md="6" lg="auto" xl="auto">
                <div class="color-grey d-flex align-center">
                  <span class="circle blue"></span>ใบเสร็จมีการกรอกส่วนสด
                  (ส่วนลดรายการ,ส่วนลดท้ายบิล)
                </div>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="6" lg="auto" xl="auto">
                <div class="color-grey d-flex align-center">
                  <span class="circle cyan"></span>ใบเสร็จไม่คิดภาษี
                </div>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="6" lg="auto" xl="auto">
                <div class="color-grey d-flex align-center">
                  <span class="circle orange"></span>
                  ใบเสร็จไม่คิดภาษีและมีส่วนลด
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-data-table v-if="tab_id == 1" :headers="headers" :items="data_list" :search="search"
                  :footer-props="footer_Props" mobile-breakpoint="0" :custom-filter="customFilter"
                  sort-by="updated_at" :sort-desc="true">
                  <template v-slot:item="dataDetail">
                    <tr>
                      <td>
                        <div class="font-16"
                          :style="getStyleDiscount(dataDetail.item.is_discount, dataDetail.item.is_vat)">
                          {{ dataDetail.item.invoice_code }}
                        </div>
                      </td>
                      <td>
                        <div class="font-16"
                          :style="getStyleDiscount(dataDetail.item.is_discount, dataDetail.item.is_vat)">
                          {{ dataDetail.item.updated_at || "-" }}
                        </div>
                      </td>
                      <td>
                        <!-- <div v-if="dataDetail.item.credit_charge_status == 1 && dataDetail.item.pay_type.find(o => o === 3)" class="font-16">{{formatPrice(parseFloat(dataDetail.item.total) + (parseFloat(dataDetail.item.total) * (parseFloat(dataDetail.item.credit_charge) / 100)))}}</div> -->
                        <div class="font-16"
                          :style="getStyleDiscount(dataDetail.item.is_discount, dataDetail.item.is_vat)">
                          {{ formatPrice(dataDetail.item.total) }}
                        </div>
                      </td>
                      <td>
                        <div v-for="(pt, index) in normalizePayType(dataDetail.item.pay_type)" :key="index" class="font-16"
                          :style="getStyleDiscount(dataDetail.item.is_discount, dataDetail.item.is_vat)">
                          {{ getPaymentType(pt, dataDetail.item.card_name_th) }}
                        </div>
                      </td>
                      <td>
                        <div class="font-16"
                          :style="getStyleDiscount(dataDetail.item.is_discount, dataDetail.item.is_vat)">
                          {{
                            dataDetail.item.user_cancel != null &&
                            String(dataDetail.item.user_cancel).trim() !== ""
                              ? dataDetail.item.user_cancel
                              : "-"
                          }}
                        </div>
                      </td>
                      <td>
                        <div
                          class="font-16"
                          :style="getStyleDiscount(dataDetail.item.is_discount, dataDetail.item.is_vat)"
                          style="white-space: pre-wrap; max-width: 280px"
                        >
                          <template v-if="hasAnyInvoiceNoteCell(dataDetail.item)">
                            <div v-if="trimmedInvoiceReason(dataDetail.item)">
                              {{ trimmedInvoiceReason(dataDetail.item) }}
                            </div>
                            <div
                              v-if="showPayNoteForInvoice(dataDetail.item)"
                              :class="trimmedInvoiceReason(dataDetail.item) ? 'mt-1' : ''"
                              style="font-size: 14px"
                            >
                              <span class="grey--text text--darken-1">ชำระอื่นๆ:</span>
                              {{ dataDetail.item.pay_note }}
                            </div>
                          </template>
                          <template v-else>-</template>
                        </div>
                      </td>
                      <td>
                        <span>
                          <span v-if="dataDetail.item.user_cancel == null">
                            <v-btn elevation="2" class="my-3 mx-1 font-16" outlined color="#EC6162" title="ยกเลิกบิล"
                              style="border-radius: 10px" @click="
                                open_model_cancel(),
                                (cancel.invoice_id = dataDetail.item.id),
                                (user_cancel = dataDetail.item.user_cancel)
                                ">ยกเลิกบิล
                            </v-btn>
                          </span>
                          <span v-else style="color: #ec6162">
                            บิลถูกยกเลิก
                          </span>
                        </span>
                      </td>
                      <td>
                        <div class="d-flex">
                          <span>
                            <v-btn elevation="2" class="my-3 mx-1 font-16" outlined color="#8EBBDC" title="ดูรายละเอียด"
                              style="border-radius: 10px" @click="
                                getDetail(dataDetail.item.id),
                                (user_cancel = dataDetail.item.user_cancel)
                                ">
                              <v-icon>mdi-magnify</v-icon>ดูรายละเอียด
                            </v-btn>
                          </span>
                          <span>
                            <v-btn elevation="2" class="my-3 mx-1 font-16" outlined color="#88B358" title="พิมพ์"
                              style="border-radius: 10px" @click="
                                open_model_print_bill(),
                                (status_invoice_tax =
                                  dataDetail.item.tax_invoice_id),
                                (status_invoice_refund =
                                  dataDetail.item.tax_refund_id),
                                (id = dataDetail.item.id),
                                (vat_type = dataDetail.item.vat_type),
                                (is_vat = dataDetail.item.is_vat),
                                (bill_status = dataDetail.item.status)
                                ">
                              <v-icon>mdi-printer</v-icon> พิมพ์
                            </v-btn>
                          </span>
                        </div>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
                <v-data-table v-if="tab_id == 2" :headers="headers" :items="data_list" :search="search" :footer-props="footer_Props"
                  mobile-breakpoint="0" :hide-default-footer="true" :custom-filter="customFilter"
                  sort-by="updated_at" :sort-desc="true">
                  <template v-slot:item="dataDetail">
                    <tr>
                      <td>
                        <div class="font-16" :style="getStyleDiscount(
                          dataDetail.item.is_discount, dataDetail.item.is_vat
                        )
                          ">
                          {{ dataDetail.item.invoice_code }}
                        </div>
                      </td>
                      <td>
                        <div class="font-16"
                          :style="getStyleDiscount(dataDetail.item.is_discount, dataDetail.item.is_vat)">
                          {{ dataDetail.item.updated_at || "-" }}
                        </div>
                      </td>
                      <td>
                        <!-- <div v-if="dataDetail.item.credit_charge_status == 1 && dataDetail.item.pay_type.find(o => o === 3)" class="font-16">{{formatPrice(parseFloat(dataDetail.item.total) + (parseFloat(dataDetail.item.total) * (parseFloat(dataDetail.item.credit_charge) / 100)))}}</div> -->
                        <div class="font-16"
                          :style="getStyleDiscount(dataDetail.item.is_discount, dataDetail.item.is_vat)">
                          {{ formatPrice(dataDetail.item.total) }}
                        </div>
                      </td>
                      <td>
                        <div v-for="(pt, index) in normalizePayType(dataDetail.item.pay_type)" :key="index" class="font-16"
                          :style="getStyleDiscount(dataDetail.item.is_discount, dataDetail.item.is_vat)">
                          {{ getPaymentType(pt, dataDetail.item.card_name_th) }}
                        </div>
                      </td>
                      <td>
                        <div class="font-16">
                          {{
                            dataDetail.item.user_cancel != null &&
                            String(dataDetail.item.user_cancel).trim() !== ""
                              ? dataDetail.item.user_cancel
                              : "-"
                          }}
                        </div>
                      </td>
                      <td>
                        <div
                          class="font-16"
                          :style="getStyleDiscount(dataDetail.item.is_discount, dataDetail.item.is_vat)"
                          style="white-space: pre-wrap; max-width: 280px"
                        >
                          <template v-if="hasAnyInvoiceNoteCell(dataDetail.item)">
                            <div v-if="trimmedInvoiceReason(dataDetail.item)">
                              {{ trimmedInvoiceReason(dataDetail.item) }}
                            </div>
                            <div
                              v-if="showPayNoteForInvoice(dataDetail.item)"
                              :class="trimmedInvoiceReason(dataDetail.item) ? 'mt-1' : ''"
                              style="font-size: 14px"
                            >
                              <span class="grey--text text--darken-1">ชำระอื่นๆ:</span>
                              {{ dataDetail.item.pay_note }}
                            </div>
                          </template>
                          <template v-else>-</template>
                        </div>
                      </td>
                      <td>
                        <span>
                          <span v-if="dataDetail.item.user_cancel == null">
                            <v-btn elevation="2" class="my-3 mx-1 font-16" outlined color="#EC6162" title="ยกเลิกบิล"
                              style="border-radius: 10px" @click="
                                open_model_cancel(),
                                (cancel.invoice_id = dataDetail.item.id),
                                (user_cancel = dataDetail.item.user_cancel)
                                ">ยกเลิกบิล
                            </v-btn>
                          </span>
                          <span v-else style="color: #ec6162">
                            บิลถูกยกเลิก
                          </span>
                        </span>
                      </td>
                      <td>
                        <div class="d-flex">
                          <span>
                            <v-btn elevation="2" class="my-3 mx-1 font-16" outlined color="#8EBBDC" title="ดูรายละเอียด"
                              style="border-radius: 10px" @click="
                                getDetail(dataDetail.item.id),
                                (user_cancel = dataDetail.item.user_cancel)
                                ">
                              <v-icon>mdi-magnify</v-icon>ดูรายละเอียด
                            </v-btn>
                          </span>
                          <span>
                            <v-btn elevation="2" class="my-3 mx-1 font-16" outlined color="#88B358" title="พิมพ์"
                              style="border-radius: 10px" @click="
                                open_model_print_bill(),
                                (status_invoice_tax =
                                  dataDetail.item.tax_invoice_id),
                                (status_invoice_refund =
                                  dataDetail.item.tax_refund_id),
                                (id = dataDetail.item.id),
                                (vat_type = dataDetail.item.vat_type),
                                (is_vat = dataDetail.item.is_vat),
                                (bill_status = dataDetail.item.status)
                                ">
                              <v-icon>mdi-printer</v-icon> พิมพ์
                            </v-btn>
                          </span>
                        </div>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-col>
              <v-col v-if="tab_id == 2" cols="12">
                <div class="text-center">
                  <v-pagination color="#d0b19b" v-model="page" :total-visible="7" :length="page_all"></v-pagination>
                </div>
              </v-col>
            </v-row>
          </section>
        </v-card>
      </div>

      <!-- รายละเอียด -->
      <v-dialog v-if="show_detail_bill" v-model="show_detail_bill" persistent max-width="650px">
        <v-card class="input-radius">
          <v-card-title class="d-flex pt-2">
            <v-row>
              <v-col cols="12 text-right pt-5 pb-1 ">
                <v-btn icon class="ma-1" @click="close_model_all()">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </v-col>

              <v-col cols="12 pt-1">
                <v-col v-if="user_cancel != null" class="border-bill-red input-radius">
                  <div class="required--text">
                    สาเหตุการยกเลิกบิล : {{ detailList.invoice.cancel_note }}
                  </div>
                </v-col>
                <v-col
                  v-if="detailList && detailList.invoice && hasAnyInvoiceNoteCell(detailList.invoice)"
                  class="input-radius pa-3 mt-2"
                  style="background: #faf6f2; border: 1px solid #e8dfd4"
                >
                  <div v-if="trimmedInvoiceReason(detailList.invoice)" class="font-14">
                    <strong>หมายเหตุบิล:</strong>
                    {{ trimmedInvoiceReason(detailList.invoice) }}
                  </div>
                  <div
                    v-if="showPayNoteForInvoice(detailList.invoice)"
                    class="font-14"
                    :class="trimmedInvoiceReason(detailList.invoice) ? 'mt-2' : ''"
                  >
                    <strong>หมายเหตุชำระอื่นๆ:</strong>
                    {{ detailList.invoice.pay_note }}
                  </div>
                </v-col>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-container class="pa-7 border-bill input-radius">
              <v-row>
                <v-col cols="4" class="title_page_right pr-0 pt-0">
                  <v-img style="background-size: contain;" height="110" width="110" :src="seller.logo_pos"
                    :lazy-src="seller.logo_pos"></v-img>
                </v-col>
                <v-col cols="7 text-center pl-0 pt-0">
                  <div class="font-16">
                    {{
                      seller.status_main_store == 1
                        ? "บริษัท ฟาร์มาแคร์ พลัส จำกัด"
                        : seller.store_name
                    }}
                  </div>
                  <div class="font-16">
                    {{ seller.address }} {{ seller.address_list }}
                  </div>
                  <div class="font-16">
                    {{ seller.owner_name }} เลขที่สาขา : {{ seller.store_code }}
                  </div>
                  <div class="font-16">
                    TAX#{{ seller.store_personal_id }} (VAT Includ)
                  </div>
                  <div class="font-16">
                    POS {{ seller.posid }}
                  </div>
                  <div class="font-16">ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ</div>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="6">
                  <div class="font-16">
                    {{ detailList.invoice.invoice_code }}
                  </div>
                </v-col>
                <v-col cols="6 text-right">
                  <div class="font-16">
                    {{
                      detailList.invoice.created_at != null
                        ? `${detailList.invoice.created_at
                          .split("-")[2]
                          .split(" ")[0]
                        }/${detailList.invoice.created_at.split("-")[1]}/${detailList.invoice.created_at.split("-")[0]
                        } @ ${detailList.invoice.created_at
                          .split("-")[2]
                          .split(" ")[1]
                        }`
                        : "-"
                    }}
                  </div>
                </v-col>
                <v-col cols="12 pt-0 pb-1">
                  <div class="border-style-b pb-2 px-4"></div>
                </v-col>
              </v-row>
              <div id="bot" class="mt-5">
                <div id="table">
                  <table>
                    <tr class="tabletitle">
                      <td class="font-13 item" style="width: 10px !important">
                        <h2>Item</h2>
                      </td>
                      <td class="font-13 text-center">
                        <h2>ราคา</h2>
                      </td>
                      <td class="font-13 text-center">
                        <h2>จำนวน</h2>
                      </td>
                      <td class="font-13 text-right">
                        <h2>รวม</h2>
                      </td>
                    </tr>

                    <tr v-for="(item, index) in detailList.invoice_list" :key="index" class="service">
                      <td class="tableitem font-13">
                        <p class="itemtext pr-2 mt-5">
                          {{ item.product_name }}
                        </p>
                        <p class="pr-2 mt-5 font-10 text-center" v-if="item.discount > 0">
                          ส่วนลด {{ item.product_name }}
                        </p>
                      </td>
                      <td class="tableitem font-13 text-center va-top">
                        <p class="itemtext mt-5">
                          {{ formatPrice(item.price) }}
                        </p>
                        <br v-if="item.discount > 0" />
                      </td>
                      <td class="tableitem font-13 text-center va-top">
                        <p class="itemtext mt-5" v-if="item.product_code == null">
                          -{{ item.qty }} {{ item.unit_name }}
                        </p>
                        <p class="itemtext mt-5" v-else>{{ item.qty }} {{ item.unit_name }}</p>
                        <br v-if="item.discount > 0" />
                      </td>
                      <td class="tableitem font-13 text-right va-top">
                        <p class="itemtext mt-5" v-if="item.product_code == null">
                          -{{
                            formatPrice(
                              (parseFloat(item.total) || 0) + (parseFloat(item.discount) || 0)
                            )
                          }}
                        </p>
                        <p class="itemtext mt-5" v-else>
                          {{
                            formatPrice(
                              (parseFloat(item.total) || 0) + (parseFloat(item.discount) || 0)
                            )
                          }}
                        </p>
                        <p class="itemtext mt-5" v-if="item.discount > 0">
                          -{{ formatPrice(item.discount) }}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="4">
                        <div class="border-style-b pb-2 px-4"></div>
                      </td>
                    </tr>

                    <tr class="tabletitle">
                      <td>
                        <p class="mt-5 font-13">รวมเงิน</p>
                      </td>
                      <td class="mt-5 font-13"></td>
                      <td>
                        <p class="mt-5 font-13 text-center">
                          {{ total_qty }} ชิ้น
                        </p>
                      </td>
                      <td class="text-right">
                        <p class="mt-5 font-12">
                          {{ formatPrice(total_price) }}
                        </p>
                      </td>
                    </tr>
                    <tr class="tabletitle">
                      <td>
                        <p class="mt-5 font-13">ส่วนลดท้ายบิล</p>
                      </td>
                      <td></td>
                      <td>
                        <p class="mt-5 font-13"></p>
                      </td>
                      <td class="text-right">
                        <p class="mt-5 font-12">
                          {{ formatPrice(detailList.invoice.discount) }}
                        </p>
                      </td>
                    </tr>
                    <tr class="tabletitle">
                      <td>
                        <p class="mt-5 font-13">มูลค่าสินค้า</p>
                      </td>
                      <td class="mt-5 font-13"></td>
                      <td>
                        <p class="mt-5 font-13 text-center">
                          {{ total_qty }} ชิ้น
                        </p>
                      </td>
                      <td class="text-right">
                        <p class="mt-5 font-12">
                          {{ formatPrice(detailList.invoice.cost) }}
                        </p>
                      </td>
                    </tr>
                    <tr class="tabletitle">
                      <td>
                        <p class="mt-5 font-13">ภาษีมูลค่าเพิ่ม 7%</p>
                      </td>
                      <td></td>
                      <td></td>
                      <td class="text-right">
                        <p class="mt-5 font-12">
                          {{ formatPrice(detailList.invoice.vat) }}
                        </p>
                      </td>
                    </tr>
                    <tr class="tabletitle" v-if="
                      detailList.invoice.credit_charge_status == 1 &&
                      detailList.invoice.pay_type.find((o) => o === 3)
                    ">
                      <td>
                        <p class="mt-5 font-13">
                          เครดิตชาร์ต
                          {{ parseFloat(detailList.invoice.credit_charge) }}%
                        </p>
                      </td>
                      <td></td>
                      <td></td>
                      <td class="text-right">
                        <p class="mt-5 font-12">
                          {{
                            formatPrice(
                              parseFloat(detailList.invoice.credit_uncharge) *
                              parseFloat(
                                detailList.invoice.credit_charge / 100
                              )
                            )
                          }}
                        </p>
                      </td>
                    </tr>
                    <tr class="tabletitle">
                      <td>
                        <p class="mt-5 font-13">ยอดเงินสุทธิ</p>
                      </td>
                      <td></td>
                      <td></td>
                      <!-- <td v-if="detailList.invoice.credit_charge_status == 1 && detailList.invoice.pay_type.find(o => o === 3)" class="text-right"><p class="mt-5 font-13">{{ formatPrice(parseFloat(detailList.invoice.total) + (parseFloat(detailList.invoice.total) * parseFloat(detailList.invoice.credit_charge / 100))) }}</p></td> -->
                      <td class="text-right">
                        <p class="mt-5 font-12">
                          {{
                            formatPrice(
                              parseFloat(parseFloat(detailList.invoice.total))
                            )
                          }}
                        </p>
                      </td>
                    </tr>
                    <tr class="tabletitle">
                      <td>
                        <p class="mt-5 font-13">รับเงิน</p>
                      </td>
                      <td></td>
                      <td></td>
                      <td class="text-right">
                        <p class="mt-5 font-12">
                          {{
                            formatPrice(
                              parseFloat(detailList.invoice.cash) +
                              parseFloat(detailList.invoice.payment) +
                              parseFloat(detailList.invoice.credit) +
                              parseFloat(detailList.invoice.etc_payment) +
                              parseFloat(detailList.invoice.qrcode_pay)
                            )
                          }}
                        </p>
                      </td>
                    </tr>
                    <tr class="tabletitle">
                      <td>
                        <p class="mt-5 font-13">เงินทอน</p>
                      </td>
                      <td></td>
                      <td></td>
                      <td class="text-right">
                        <p class="mt-5 font-12">
                          {{
                            formatPrice(parseFloat(detailList.invoice.change))
                          }}
                        </p>
                      </td>
                    </tr>

                    <tr>
                      <td colspan="4" v-if="seller.status_main_store != 1">
                        <div class="color-gray-mid font-10 mt-10">
                          * สาขา{{ seller.store_name }} {{ seller.tel }} *
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colspan="4">
                        <div class="border-style-b pb-2 px-4"></div>
                      </td>
                    </tr>

                    <tr>
                      <td colspan="4">
                        <div class="font-12">
                          ข้อมูลสมาชิก {{ detailList.invoice.member_name }}
                        </div>
                      </td>
                    </tr>
                    <br />
                    <tr>
                      <td class="item"></td>
                      <td>
                        <p class="font-12 text-center">ได้รับ</p>
                      </td>
                      <td>
                        <p class="font-12 text-center">ใช้ไป</p>
                      </td>
                      <td>
                        <p class="font-12 text-center">คงเหลือ</p>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <p class="font-12 mt-5">แต้มสมาชิก</p>
                      </td>
                      <td>
                        <p class="font-12 text-center mt-5">
                          +{{
                            detailList.invoice.member_name == null
                              ? formatPrice(0)
                              : formatPrice(detailList.invoice.point)
                          }}
                        </p>
                      </td>
                      <td>
                        <p class="font-12 text-center mt-5">
                          {{ formatPrice(detailList.invoice.use_point) }}
                        </p>
                      </td>
                      <td>
                        <p class="font-12 text-center mt-5">
                          {{ formatPrice(detailList.invoice.point_remain) }}
                        </p>
                      </td>
                    </tr>

                    <tr>
                      <td colspan="4">
                        <div class="color-gray-mid font-10 mt-4">
                          ** ยอดใช้ไปและยอดคงเหลือ ไม่รวมยอดสะสมครั้งนี้ **
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
                <!--End Table-->

                <div id="legalcopy" class="text-center">
                  <p class="font-14">ขอบคุณที่ใช้บริการ</p>
                </div>
              </div>
              <!--End InvoiceBot-->
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- ปุ่มยกเลิก -->
      <v-dialog v-model="show_cancel_bill" persistent max-width="600px">
        <v-card class="input-radius pa-5">
          <v-card-title>
            <v-row>
              <v-col class="pt-4">
                <div class="bold font-20">ยกเลิกใบเสร็จ</div>
              </v-col>
              <v-col class="text-right">
                <v-btn icon class="ma-1" @click="close_model_all()">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-checkbox v-model="cancel.check" label="ต้องการนำสินค้าคืนคลัง" color="#D6BFAF" :disabled="true"
                  :input-value="true" hide-details>
                </v-checkbox>
              </v-col>
              <v-col cols="12" @click="toggleCheckbox()">
                <label label class="label_form_text">สาเหตุการยกเลิกใบเสร็จ
                  <span class="required--text">*</span></label>
                <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-home" hide-details="auto"
                  v-model="cancel.note" placeholder="กรุณากรอกสาเหตุการยกเลิกใบเสร็จ"
                  :rules="[(v) => !!v || 'กรุณากรอกข้อมูล']" single-line outlined dense required>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                <label label class="label_form_text">เบอร์โทรเข้าสู่ระบบ
                  <span class="required--text">*</span></label>
                <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-account" hide-details="auto"
                  v-model="cancel.tel" placeholder="กรุณากรอกเบอร์โทรเข้าสู่ระบบ"
                  :rules="[(v) => !!v || 'กรุณากรอกข้อมูล']" single-line outlined dense required>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                <label label class="label_form_text">รหัสผ่าน <span class="required--text">*</span></label>
                <v-text-field label="รหัสผ่าน" class="input-radius" prepend-inner-icon="mdi-lock"
                  v-model="cancel.password" color="#D6BFAF" hide-details="auto"
                  :rules="[(v) => !!v || 'กรุณากรอกข้อมูล']" :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show ? 'text' : 'password'" @click:append="show = !show" single-line outlined dense
                  required></v-text-field>
              </v-col>
              <v-col cols="12 text-right">
                <div class="text-right mt-5">
                  <v-btn @click="saveCancelInvoice()" type="submit" height="45" width="150"
                    class="white--text grad-success-arin-bg mobile_btn"
                    style="font-size: 18px; border-radius: 10px">ยกเลิกบิล</v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Modal การแจ้งเตือนเสร็จสิ้น -->
      <v-dialog v-model="show_check_bill_success" persistent max-width="500px">
        <v-card class="input-radius pa-5">
          <v-card-title>
            <v-row>
              <v-col class="text-right py-0">
                <v-btn icon class="ma-1" @click="close_model_all()">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text class="pb-10">
            <v-row>
              <v-col cols="12 title_page_center">
                <div class="text-center">
                  <v-img width="178" class="w-100" :src="img_check"></v-img>
                </div>
              </v-col>
              <v-col cols="12 text-center">
                <h1 class="">ยกเลิกใบเสร็จสำเร็จ</h1>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="show_print_bill" persistent max-width="650px" >
        <v-card class="input-radius pa-5">
          <v-card-title>
            <v-row>
              <v-col cols="">
                <div class="bold font-20">เลือกใบเสร็จที่ต้องการปริ้น</div>
              </v-col>
              <v-col class="text-right py-0">
                <v-btn icon class="ma-1" @click="close_model_all()">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>

          <v-container fluid>
            <v-row dense>
              <v-col cols="4 px-2">
                <v-card class="input-radius" elevation="2">
                  <v-row>
                    <v-col cols="12 title_page_center pt-7">
                      <v-img width="70" height="70" :lazy-src="img_bill" :src="img_bill"></v-img>
                    </v-col>
                    <v-col cols="12 pt-0">
                      <div class="text-center">ใบเสร็จอย่างย่อ</div>
                    </v-col>
                  </v-row>
                  <v-card-actions class="text-center title_page_center">
                    <v-btn elevation="1" class="my-3 mx-1 font-16" outlined color="#88B358" title="พิมพ์" @click="linkPage()"
                      style="border-radius:10px">
                      <v-icon>mdi-printer</v-icon> พิมพ์
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="4 px-2">
                <v-card class="input-radius" elevation="2">
                  <v-row>
                    <v-col cols="12 title_page_center pt-7">
                      <v-img width="70" height="70" :lazy-src="img_billpayment" :src="img_billpayment"></v-img>
                    </v-col>
                    <v-col cols="12 pt-0">
                      <div class="text-center">ใบแจ้งหนี้/ใบกำกับภาษี</div>
                    </v-col>
                  </v-row>
                  <v-card-actions class="text-center title_page_center">
                    <v-btn elevation="1" class="my-3 mx-1 font-16" outlined color="#88B358" title="พิมพ์"
                      style="border-radius:10px" @click="status_invoice_tax == null ? link('/arin/pos/posinvoicestaxadd/'+id) : link('/arin/pos/pospapertaxinvoices?id='+id)" :disabled="bill_status == 2 || is_vat == 0 ">
                      <v-icon>mdi-printer</v-icon> พิมพ์
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="4 px-2">
                <v-card class="input-radius" elevation="2">
                  <v-row>
                    <v-col cols="12 title_page_center pt-7">
                      <v-img width="70" height="70" :lazy-src="img_tax" :src="img_tax"></v-img>
                    </v-col>
                    <v-col cols="12 pt-0">
                      <div class="text-center">ใบ Tax Refund</div>
                    </v-col>
                  </v-row>
                  <v-card-actions class="text-center title_page_center">
                    <v-btn elevation="1" class="my-3 mx-1 font-16" outlined color="#88B358" title="พิมพ์"
                      style="border-radius:10px" @click="status_invoice_refund == null ? link('/arin/pos/posinvoicestaxrefundadd/'+id) : ''" :disabled="bill_status == 2 || is_vat == 0">
                      <v-icon>mdi-printer</v-icon> พิมพ์
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <div v-if="print_receipt" class="d-none">
        <iframe :src="'/arin/pos/posinvoicereceipt?id=' + id + '&vat_status=' + vat_type
          " title="print_receipt"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import img_arin from "@/assets/arin_assets/arin.png";
import img_check from "@/assets/arin_assets/check_success.png";
import img_bill from "@/assets/arin_assets/bill.png";
import img_billpayment from "@/assets/arin_assets/billpayment.png";
import img_tax from "@/assets/arin_assets/tax_two.png";
import { HTTP_ARIN } from "@/axios_arin";
import { formatPrice } from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Pos_bill_after",
  data() {
    return {
      loading_page: false,
      dialog_cancel_order: false,
      search: "",
      tab_id: 1,
      show_detail_bill: false,
      show: false,
      show_cancel_bill: false,
      show_check_bill_success: false,
      show_print_bill: false,
      img_arin: img_arin,
      img_check: img_check,
      img_bill: img_bill,
      img_billpayment: img_billpayment,
      img_tax: img_tax,

      checkbox_cancel_import: false,
      note_cancel_import: null,
      tel_login: null,
      password: null,

      footer_Props: {
        "items-per-page-text": "รายการต่อหน้า",
      },
      headers: [
        {
          text: "เลขที่ใบเสร็จ",
          value: "invoice_code",
          fixed: true,
          width: "130px",
          sortable: true,
        },
        {
          text: "วัน-เวลา",
          value: "updated_at",
          fixed: true,
          width: "130px",
          sortable: true,
          sort: (a, b) => {
            if (!a || !b) return 0;
            const dateA = new Date(a);
            const dateB = new Date(b);
            if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) return 0;
            return dateA - dateB;
          },
        },
        {
          text: "ยอดขาย",
          value: "total",
          fixed: true,
          width: "130px",
          sortable: true,
          sort: (a, b) => parseFloat(a) - parseFloat(b),
        },
        {
          text: "การชำระเงิน",
          value: "",
          fixed: true,
          width: "130px",
          sortable: false,
        },
        {
          text: "ผู้ยกเลิก",
          value: "receipt_cancel",
          fixed: true,
          width: "200px",
          sortable: true,
        },
        {
          text: "หมายเหตุ (บิล / ชำระอื่นๆ)",
          value: "reason",
          fixed: true,
          width: "220px",
          sortable: false,
        },
        {
          text: "สถานะ",
          value: "receipt_status",
          fixed: true,
          width: "150px",
          sortable: true,
        },
        {
          text: "จัดการ",
          value: "",
          fixed: true,
          width: "120px",
          sortable: false,
        },
      ],
      data_list: [],
      sub_menu: [
        {
          text: "ระบบ POS",
          disabled: false,
        },
        {
          text: "การขาย",
          disabled: false,
        },
        {
          text: "รายการบิลย้อนหลัง",
          disabled: false,
        },
      ],
      detailList: [],
      page: 1,
      page_all: 1,
      searchTimer: null,
      total_qty: null,
      print_receipt: false,
      vat_type: null,
      bill_status: null,
      invoice_id: null,
      total_price: null,
      user_cancel: null,
      seller: {},
      cancel: {
        invoice_id: null,
        check: true,
        note: null,
        tel: null,
        password: null,
      },
      id: null,
      status_invoice_tax: null,
      status_invoice_refund: null,
      vowelCharacters: "aeiouAEIOUะัาำิีึื็ุู่้๊๋์ํๆ",
    };
  },
  methods: {
    async linkPage() {
      this.print_receipt = await false;
      this.print_receipt = await true;
    },
    truncateString(product_name) {
      var maxLength = 15;
      var truncatedString = "";
      var characterCount = 0;

      for (var i = 0; i < product_name.length; i++) {
        var character = product_name[i];
        truncatedString += character;

        if (this.vowelCharacters.indexOf(character) === -1) {
          characterCount++;
        }

        if (characterCount >= maxLength) {
          break;
        }
      }

      if (product_name.length > maxLength) {
        truncatedString += "...";
      }

      product_name = truncatedString;
      return product_name;
    },
    link(link) {
      window.location.href = link;
    },
    getPaymentType(item, cardName) {
      switch (item) {
        case 0:
          return "ยังไม่ได้จ่าย";
        case 1:
          return "เงินสด ";
        case 2:
          return "เงินโอน ";
        case 3:
          // ถ้ามี cardName ก็แสดง "เครดิต (Alipay)" ถ้าไม่มีก็แค่ "เครดิต"
          return cardName
            ? `เครดิต (${cardName})`
            : "เครดิต ";
        case 4:
          return "อื่นๆ ";
        case 5:
          return "QR Code ";
        default:
          return "-";
      }
    },
    normalizePayType(payType) {
      if (payType == null) return [];
      if (Array.isArray(payType)) return payType;
      if (typeof payType === "string") {
        try {
          const p = JSON.parse(payType);
          return Array.isArray(p) ? p : [];
        } catch (e) {
          return [];
        }
      }
      return [];
    },
    payTypeIncludesOther(payType) {
      return this.normalizePayType(payType).some(
        (x) => parseInt(x, 10) === 4
      );
    },
    trimmedInvoiceReason(item) {
      if (!item || item.reason == null) return "";
      const s = String(item.reason).trim();
      return s;
    },
    showPayNoteForInvoice(item) {
      if (!item) return false;
      return (
        this.payTypeIncludesOther(item.pay_type) &&
        item.pay_note != null &&
        String(item.pay_note).trim() !== ""
      );
    },
    hasAnyInvoiceNoteCell(item) {
      return (
        !!this.trimmedInvoiceReason(item) ||
        this.showPayNoteForInvoice(item)
      );
    },
    open_model_bill() {
      this.show_detail_bill = true;
    },
    open_model_cancel() {
      this.show_cancel_bill = true;
    },
    open_model_bill_success() {
      this.show_check_bill_success = true;
    },
    open_model_print_bill() {
      this.show_print_bill = true;
    },
    close_model_all() {
      this.show_detail_bill = false;
      this.show_cancel_bill = false;
      this.show_check_bill_success = false;
      this.show_print_bill = false;
    },
    tabs(number) {
      this.tab_id = number;
      if (number == 1) {
        this.getBillDay();
      } else if (number == 2) {
        this.getBillAll();
      }
    },
    formatPrice(number) {
      return formatPrice(number);
    },
    customFilter(value, search, item) {
      if (!search) return true;
      
      const searchText = search.toLowerCase().trim();
      
      // Debug: ดูค่าที่ค้นหา
      if (searchText === '17/01' || searchText === '17/01/2025') {
        console.log('Searching for:', searchText);
        console.log('Item:', item);
        console.log('updated_at:', item.updated_at);
      }
      
      // ค้นหาเลขที่ใบเสร็จ
      if (item.invoice_code && item.invoice_code.toLowerCase().includes(searchText)) {
        return true;
      }
      
      // ค้นหาวัน-เวลา (ทั้งข้อมูลดิบและ format แล้ว)
      if (item.updated_at) {
        const dateRaw = item.updated_at.toLowerCase();
        
        // ค้นหาจากข้อมูลดิบก่อน (เช่น "2024-09-26", "2025-01-17")
        if (dateRaw.includes(searchText)) {
          return true;
        }
        
        // Format date: DD/MM/YYYY HH:mm:ss
        try {
          // ตัวอย่าง: "2025-01-17 13:59:00"
          const dateParts = item.updated_at.split('-');
          if (dateParts.length === 3) {
            const year = dateParts[0]; // 2025
            const month = dateParts[1]; // 01
            const dayTime = dateParts[2]; // "17 13:59:00"
            const dayTimeParts = dayTime.split(' ');
            const day = dayTimeParts[0]; // 17
            const time = dayTimeParts[1] || ''; // "13:59:00"
            
            // Format วันที่แบบต่างๆ
            const formattedDate1 = `${day}/${month}/${year} ${time}`.toLowerCase().trim();
            const formattedDate2 = `${day}/${month}/${year}`.toLowerCase();
            const formattedDate3 = `${day}/${month}`.toLowerCase(); // "17/01"
            const formattedDate4 = `${month}/${year}`.toLowerCase();
            const formattedDate5 = `${year}-${month}-${day}`.toLowerCase();
            
            // ค้นหาจากรูปแบบที่ format แล้ว
            if (formattedDate1.includes(searchText) || 
                formattedDate2.includes(searchText) || 
                formattedDate3.includes(searchText) ||
                formattedDate4.includes(searchText) ||
                formattedDate5.includes(searchText)) {
              return true;
            }
            
            // ค้นหาแบบแยกส่วน (เช่น "17", "01", "2025", "13:59")
            if (day.includes(searchText) || month.includes(searchText) || year.includes(searchText) || time.includes(searchText)) {
              return true;
            }
          }
        } catch (e) {
          // ถ้า format ไม่ได้ ให้ค้นหาจากข้อมูลดิบ
          if (dateRaw.includes(searchText)) {
            return true;
          }
        }
      }
      
      // ค้นหายอดขาย (ทั้งข้อมูลดิบและ format แล้ว)
      if (item.total) {
        const totalRaw = item.total.toString().toLowerCase();
        const totalFormatted = this.formatPrice(item.total).toLowerCase().replace(/,/g, '');
        const totalNumber = parseFloat(item.total).toString();
        
        if (totalRaw.includes(searchText) || totalFormatted.includes(searchText) || totalNumber.includes(searchText)) {
          return true;
        }
      }
      
      // ค้นหาการชำระเงิน
      const payTypes = this.normalizePayType(item.pay_type);
      if (payTypes.length) {
        const paymentTexts = payTypes
          .map((pay) => this.getPaymentType(pay, item.card_name_th))
          .join(" ")
          .toLowerCase();
        if (paymentTexts.includes(searchText)) {
          return true;
        }
      }
      
      // ค้นหาผู้ยกเลิก
      if (item.user_cancel && item.user_cancel.toString().toLowerCase().includes(searchText)) {
        return true;
      }

      // ค้นหาหมายเหตุ
      if (
        item.reason != null &&
        String(item.reason).toLowerCase().includes(searchText)
      ) {
        return true;
      }

      if (
        item.pay_note != null &&
        String(item.pay_note).toLowerCase().includes(searchText)
      ) {
        return true;
      }
      
      return false;
    },
    getBillDay() {
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.get(`/invoice/list/current/day`, config).then((res) => {
        if (res.data.successful === true) {
          this.data_list = res.data.data;
        }
      });
    },
    convertSearchDate(searchText) {
      if (!searchText) return searchText;
      
      // ตรวจสอบว่าเป็นรูปแบบวันที่ DD/MM หรือ DD/MM/YYYY หรือไม่
      // เช่น "17/01" หรือ "17/01/2025"
      const datePattern = /^(\d{1,2})\/(\d{1,2})(?:\/(\d{4}))?$/;
      const match = searchText.match(datePattern);
      
      if (match) {
        const day = match[1].padStart(2, '0');
        const month = match[2].padStart(2, '0');
        const year = match[3] || new Date().getFullYear();
        
        // แปลงเป็น YYYY-MM-DD หรือ YYYY-MM
        if (match[3]) {
          // มีปี: แปลงเป็น "2025-01-17"
          return `${year}-${month}-${day}`;
        } else {
          // ไม่มีปี: แปลงเป็น "2025-01" (ใช้ปีปัจจุบัน)
          return `${year}-${month}`;
        }
      }
      
      // ถ้าไม่ใช่รูปแบบวันที่ ให้ส่งคืนค่าเดิม
      return searchText;
    },
    getBillAll() {
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      
      // แปลงวันที่ก่อนส่งไปที่ API
      const convertedSearch = this.convertSearchDate(this.search);
      
      HTTP_ARIN.get(
        `/invoice/list?search=${convertedSearch}&page=${this.page}&size=10`,
        config
      ).then((res) => {
        if (res.data.successful === true) {
          this.data_list = res.data.data;
          this.page = parseInt(
            res.data.current_page ? res.data.current_page : 1
          );
          this.page_all = res.data.count_page ? res.data.count_page : 1;
        }
      });
    },
    async getSotre() {
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      let store_id = this.$store.state.store_arin.user_data.store_id;
      await HTTP_ARIN.get("/stores/detail/" + store_id, config).then((res) => {
        if (res.data.successful === true) {
          this.seller = res.data.storeDetail;
        }
      });
    },
    async getDetail(id) {
      this.total_qty = 0;
      this.total_price = 0;
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      await HTTP_ARIN.get(`/pos/invoice/detail/${id}`, config).then((res) => {
        if (res.data.successful === true) {
          this.detailList = res.data.data;
          this.detailList.invoice_list.forEach((detail) => {
            if (detail.product_code != null) {
              this.total_qty += parseFloat(detail.qty);
              this.total_price += parseFloat(detail.total);
            }
          });
          this.getSotre();
          this.show_detail_bill = true;
        }
      });
    },
    async saveCancelInvoice() {
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      let data = {
        status_return_product: this.cancel.check == 1,
        cancel_note: this.cancel.note,
        tel: this.cancel.tel,
        password: this.cancel.password,
      };
      await HTTP_ARIN.post(
        `/pos/invoice/cancle/${this.cancel.invoice_id}`,
        data,
        config
      ).then((res) => {
        if (res.data.successful === true) {
          this.cancel.invoice_id = null;
          this.cancel.check = true;
          this.cancel.note = null;
          this.cancel.tel = null;
          this.cancel.password = null;
          this.show_cancel_bill = false;
          this.show_check_bill_success = true;
          this.id = this.cancel.invoice_id;
          this.print_receipt = true;
          this.print_receipt = false;
          this.tabs(this.tab_id);
        } else if (res.data.successful === false) {
          this.alert_error = true;
          this.alert_message_error = "เบอร์โทรหรือรหัสผ่านไม่ถูกต้อง";
          setTimeout(() => (this.alert_error = false), 5000);
        }
      });
    },
    getStyleDiscount(is_dis, is_vat) {
      if (is_vat == 0 && is_dis == 1) return "color:#EF8D1E"
      else if (is_vat == 1 && is_dis == 1) return "color:#5353d3"
      else if (is_vat == 0 && is_dis == 0) return "color:#53cdd3"
      else return ""
    },
  },
  mounted() {
    this.tabs(1);
  },
  watch: {
    search() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.page = 1;
        this.getBillAll();
      }, 500);
    },
    page() {
      this.getBillAll();
    },
  },
};
</script>

<style scoped>
.btn_add_data {
  font-size: 16px;
  color: #fff;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%),
    #88b358 !important;
  border-radius: 10px;
  /* width: 100%; */
}

.v-btn:not(.v-btn--round).v-size--default {
  height: 36px;
  min-width: 45px;
  padding: 0 10px;
}

.border-bill {
  border: 1px solid #f0f0f0;
}

.border-bill-red {
  border: 1px solid #ec6162;
}

.border-style-b {
  /* border-style: dotted;
    border-color: #ADADAD; */
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-bottom: 1px dotted #adadad;
}

.title_page_right {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title_page_center {
  display: flex;
  flex-direction: column;
  align-items: center;
}

#invoice-POS {
  box-shadow: 0 0 1in -0.25in rgba(0, 0, 0, 0.5);
  padding: 2mm;
  margin: 0 auto;
  width: 80mm;
  background: #fff;
}

::selection {
  background: #f31544;
  color: #fff;
}

::moz-selection {
  background: #f31544;
  color: #fff;
}

h1 {
  font-size: 1.5em;
  color: #000000;
}

h2 {
  font-size: 1.2em;
}

h3 {
  font-size: 1.2em;
  font-weight: 300;
  line-height: 2em;
}

p {
  font-size: 1em;
  color: #000000;
  line-height: 1.2em;
}

#top,
#mid,
#bot {
  /* Targets all id with 'col-' */
  border-bottom: 1px solid #eee;
}

#top {
  min-height: 100px;
}

#mid {
  min-height: 80px;
}

#bot {
  min-height: 50px;
}

#top .logo {
  /*float: left;*/
  /* height: 60px; */
  width: 150px;
  /* background: url('img_arin') no-repeat; */
  background-size: 60px 60px;
}

.clientlogo {
  float: left;
  height: 60px;
  width: 60px;
  background: url(http://michaeltruong.ca/images/client.jpg) no-repeat;
  background-size: 60px 60px;
  border-radius: 50px;
}

.info {
  display: block;
  /*float:left;*/
  margin-left: 0;
}

.title {
  float: right;
}

.title p {
  text-align: right;
}

table {
  width: 100%;
  border-collapse: collapse;
}

td p {
  font-size: 0.9em;
  /*padding: 5px 0 5px 15px;*/
  /*border: 1px solid #EEE*/
}

.tabletitle {
  /*padding: 5px;*/
  font-size: 0.6em;
  /* background: #EEE; */
}

.service {
  border-bottom: 0px solid #eee;
}

.item {
  width: 40mm;
}

.item-med {
  width: 15mm;
}

.itemtext {
  font-size: 0.9em;
}

.Rate {
  font-size: 0.9em;
}

.payment {
  font-size: 1.2em;
}

#legalcopy {
  margin-top: 7mm;
  margin-bottom: 7mm;
}

.flex-center {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.pr-5 {
  padding-right: 5px;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.w-100 {
  width: 100%;
}

.color-gray {
  color: #000000;
}

.color-gray-mid {
  color: #000000;
}

.va-top {
  vertical-align: top;
}

.mt-10 {
  margin-top: 10px;
}

.mt-5 {
  margin-top: 7px;
}

.mt-4 {
  margin-top: 4px;
}

.font-12 {
  font-size: 14px;
}

.font-13 {
  font-size: 15px;
}

.color-grey {
  color: #9d9d9d;
}

.circle {
  display: inline-block;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  margin-right: 5px;
}

.blue {
  background-color: #5353d3 !important;
}

.cyan {
  background-color: #53cdd3 !important;
}

.orange {
  background-color: #ef8d1e !important;
}
</style>
